<template>
  <div class="order-info" v-if="detail.id">
    <div class="page-warp">
      <div class="top-info-box">
        <img src="@static/images/order/info-icon.png" class="" />
        <span>退保后被保险人将失去现有保障，请确认您是投保人且自愿退保</span>
      </div>
      <div class="form-box">
        <div class="form-title">保单信息</div>
        <div class="form-row">
          <div class="label">产品名称</div>
          <div class="text">{{ detail.productName }}</div>
        </div>
        <div class="form-row">
          <div class="label">承保公司</div>
          <div class="text">{{ detail.companyName }}</div>
        </div>
        <div class="form-row">
          <div class="label">保单号</div>
          <div class="text">{{ detail.policyNo }}</div>
        </div>
        <div class="form-row">
          <div class="label">投保人</div>
          <div class="text">{{ detail.policyerName }}</div>
        </div>
        <div class="form-row">
          <div class="label">被保险人</div>
          <div class="text">{{ detail.insureders }}</div>
        </div>
        <div class="form-row">
          <div class="label">保费</div>
          <div class="text">￥{{ detail.fee }}</div>
        </div>
      </div>
      <div class="form-box line">
        <div class="form-row">
          <div class="label">退保原因</div>
          <div class="text" @click="openSelect('reasonCode')">
            <span v-if="getText('reasonCode')">{{ getText('reasonCode') }}</span>
            <span v-else class="gray-text">请选择</span>
            <i class="icon-xiangyou"></i>
          </div>
        </div>
        <div class="form-row">
          <div class="label">退款方式</div>
          <div class="text" @click="openSelect('type')">
            <span v-if="getText('type')">{{ getText('type') }}</span>
            <span v-else class="gray-text">请选择</span>
            <i class="icon-xiangyou"></i>
          </div>
        </div>
        <!-- 原路退回 -->
        <template v-if="formData.type == 1">
          <div class="form-row">
            <div class="label">银行</div>
            <div class="text">{{ detail.bankName }}</div>
          </div>
          <div class="form-row">
            <div class="label">户名</div>
            <div class="text">{{ detail.policyerName }}</div>
          </div>
          <div class="form-row">
            <div class="label">银行卡号</div>
            <div class="text">{{ detail.bankCardNo }}</div>
          </div>
        </template>
        <!-- 换卡退回 -->
        <template v-else-if="formData.type == 2">
          <div class="form-row">
            <div class="label">银行</div>
            <div class="text" @click="openSelect('bankCode')">
              <span v-if="getText('bankCode')">{{ getText('bankCode') }}</span>
              <span v-else class="gray-text">请选择</span>
              <i class="icon-xiangyou"></i>
            </div>
          </div>
          <div class="form-row">
            <div class="label">户名</div>
            <div class="text">{{ detail.policyerName }}</div>
          </div>
          <div class="form-row">
            <div class="label">银行卡号</div>
            <input class="text" type="text" placeholder="请输入" v-model="formData.bankNumber" />
          </div>
        </template>
        <div class="form-row">
          <div class="label">退款时效</div>
          <div class="text">保险公司收到解除合同申请后会及时审核您的退保业务并进行资金支付，业务审核时间和到账时间分别为1-2个工作日。</div>
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <div class="xy-box" @click="openXY()">
        <div class="radio" :class="{ 'active': radio }">
          <i class="icon-tongguo"></i>
        </div>
        <div>我已阅读并同意</div>
        <div class="blue">《退保声明》</div>
      </div>
      <div class="btn" @click="submit()">下一步</div>
    </div>

    <!-- 选择弹窗 -->
    <van-popup v-model="showSelect" position="bottom">
      <van-picker
        show-toolbar
        :title="selectTitle"
        value-key="name"
        :columns="columns"
        @cancel="showSelect = false"
        @confirm="onSelectConfirm"
        :default-index="defaultIndex"
      />
    </van-popup>
    <!-- 协议声明 -->
    <xy-popup ref="xyPopup" @ok="radio = true" />
  </div>
</template>

<script>
import xyPopup from './xyPopup';
export default {
  components: { xyPopup },
  props: {
    detail: null
  },
  data() {
    return {
      radio: false,
      orderNo: '',
      policyNo: '',
      realPolicyNo: '',
      plat: '',
      formData: {},
      //退款方式列表
      wayList: [
        { name: '原路退回', code: 1 },
        { name: '换卡退回', code: 2 }
      ],
      bankList: [], // 银行列表
      reasonList: [], //退款原因列表
      listMap: {
        'type': 'wayList',
        'reasonCode': 'reasonList',
        'bankCode': 'bankList'
      },
      defaultIndex: 0,
      selectTitle: '',
      selectKey: '',
      showSelect: false,
      columns: []
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.orderNo = this.$route.query.key;
    this.policyNo = this.$route.query.policyNo;
    this.realPolicyNo = this.$route.query.realPolicyNo;
    this.plat = this.$route.query.plat;
    this.getDic();
    this.$weixin.hideMenu();
  },
  methods: {
    submit() {
      if (!this.radio) {
        this.$notice.msg('请先阅读并同意《退保声明》');
        return;
      }
      const formData = JSON.parse(JSON.stringify(this.formData));
      formData.insureUniqueId = this.orderNo;
      if (!formData.reasonCode) {
        this.$notice.msg('请选择退保原因');
        return;
      }
      if (!formData.type) {
        this.$notice.msg('请选择退款方式');
        return;
      }
      if (formData.type == 2) {
        if (!formData.bankCode) {
          this.$notice.msg('请选择银行');
          return;
        }
        if (!formData.bankNumber) {
          this.$notice.msg('请输入银行卡号');
          return;
        }
      } else {
        delete formData.bankCode;
        delete formData.bankNumber;
      }
      const loadingObj = this.$notice.loading('加载中...');
      this.$http({
        type: 'POST',
        url: `/api/refund/getRefundInfo`,
        data: formData
      })
        .then(res => {
          const data = res.data;
          if (data.refundAmount) {
            this.$notice.inquiry(
              `您的退保金额是：${data.refundAmount}元，请问是否退保？`,
              ['否', '是'],
              () => {},
              () => {
                this.$emit('next');
              }
            );
          } else {
            this.$notice.msg('暂无退保金额');
          }
        })
        .finally(() => {
          this.$notice.close(loadingObj);
        });
    },
    getDic() {
      this.$http({
        type: 'GET',
        url: `/api/refund/dicList`
      }).then(res => {
        const data = res.data;
        this.bankList = data.bankList;
        this.reasonList = data.refundReasonList;
      });
    },
    openSelect(key) {
      this.selectKey = key;
      const value = this.formData[key];
      if (key == 'type') {
        this.selectTitle = '选择退款方式';
      } else if (key == 'reasonCode') {
        this.selectTitle = '选择退保原因';
      } else if (key == 'bankCode') {
        this.selectTitle = '选择银行';
      }
      this.columns = this[this.listMap[key]];
      this.defaultIndex = this.columns.findIndex(item => item.code === value);
      this.showSelect = true;
    },
    // 确定选择
    onSelectConfirm(data) {
      const key = this.selectKey;
      this.formData[key] = data.code;
      if (key == 'reasonCode') {
        this.formData.reason = data.name;
      } else if (key == 'bankCode') {
        this.formData.bankName = data.name;
      }
      this.showSelect = false;
    },
    getText(key) {
      const value = this.formData[key];
      const columns = this[this.listMap[key]];
      const item = columns.find(item => item.code === value);
      return item ? item.name : '';
    },
    // 打开协议弹窗
    openXY() {
      this.$refs.xyPopup.open();
    }
  }
};
</script>
<style lang="scss" scoped>
@import './orderInfo.scss';
</style>